import { TrackingState } from '@common/state/tracking/state'
import { buyTrackingActions } from '@buy/state/tracking/actions'

export const mapBuyTrackingState = () => {
    return {}
}

export const mapBuyTrackingActions = {
    track: (trackingInfo: TrackingState, component: string) => buyTrackingActions.track(trackingInfo, component),
}

export type BuyTrackingActionsType = typeof mapBuyTrackingActions

export interface BuyTrackingContextType {
    track: typeof mapBuyTrackingActions.track
}
